import axios from 'axios'

const getCountryCode = (ip,countryCode) => {
  if (countryCode)
    return Promise.resolve(countryCode)

  let body = {};

  if(ip)
  {
    body.ip = ip;
  }
  return axios({
      url: 'https://api-internal-us-east-1.viewlift.com/ip/ipgeolocator', // todo: hardcoded for now
      method: 'POST',
      data:body,
    }).then(res => {
      console.log(`${new Date()} Fetched country code\n`)
      return res.data.countryisocode
    })
}

export default getCountryCode;
